import EmptyState from '@atlaskit/empty-state';
import { HeadCell, SearchResultColumn } from '@css-xp/base';
import { generatedTypesNew } from '@css-xp/graphtypes';

export interface OrderHistoryTableProps {
  transactionAccountId: string;
  label?: string;
  testId?: string;
  filters?: generatedTypesNew.FilterOption[];
  isSearchHidden?: boolean;
  error?: any;
  // shouldNotGroupRows is used to show the rows without grouping by order number. By default, it is set to 'false'.
  shouldNotGroupRows?: boolean;
  isExportingCSVHidden?: boolean;
  isFlatDiscountSupportEnabled?: boolean;
  emptyStateProp?: React.ComponentProps<typeof EmptyState>;
  emptyStatePropForSearch?: React.ComponentProps<typeof EmptyState>;
  shouldHideFilters?: boolean;
  searchTerm?: string;
  columnsToShow?: OrderHistoryTableColumns[];
  shouldEnableFrontEndSearch?: boolean;
}

export enum OrderHistoryTableColumns {
  SUBSCRIPTION = 'Subscription',
  PLAN = 'Plan',
  SITE = 'Site',
  ORDER_DATE = 'Order date',
  COMPANY = 'Company',
  SOLD_TO = 'Sold-to address',
  NOTE = 'Notes',
  SUPPORT_TICKET = 'Support ticket',
  ORDER_SUMMARY = 'Order summary',
  PLACED_BY = 'Placed by',
  CREATED_BY = 'Created by',
  ORDER_TYPE = 'Order type',
}

export interface DateRangeState {
  from?: string;
  to?: string;
}

export type ColumnList = HeadCell & SearchResultColumn;
